import React from 'react';
import classNames from 'classnames';
import { localeURI } from '../../utils/util';
import welcome1 from '../images/modal_welcome_1.png';
import twitter_logo from '../images/white_twitter.png';
// import tiktok_logo from '../images/white_tiktok.png';

// import steam_logo from '../images/steam_logo.jpg';
import './ConnectPlatforms.scss';
import check_logo from './check_logo.png';
import youtube_logo from '../images/youtube-logo-white.png';
// import facebook_logo from '../images/facebook-logo-white.png';




class ConnectPlatforms extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      connectTwitch: 0,
      connectYoutube: 0,
      connectTwitter: 0,
      connectSteam: 0,
      connectFaceBook: 0,
    };
  }

  connectTwitch = () => {
    const { user } = this.props.auth;
    if (user.connectedAccounts.twitch.id || user.connectedAccounts.twitch.username) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/twitch');
    // The following logic to reset state might not be necessary if redirect happens immediately
    // if (this.state.connectTwitch === 2) {
    //   this.setState({
    //     connectTwitch: 0,
    //   });
    // }
  }

  connectTwitter = () => {
    const { user } = this.props.auth;
    if (user.connectedAccounts.twitter && (user.connectedAccounts.twitter.id || user.connectedAccounts.twitter.username)) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/twitter');
    // if (this.state.connectTwitter === 2) { // This condition seems unlikely to be met due to immediate redirect
    //   this.setState({
    //     connectTwitter: 0, // Corrected from connectTwitch
    //   });
    // }
  }

  connectYoutube = () => {
    const { user } = this.props.auth;
    if (user?.connectedAccounts?.youtube?.id) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/youtube');
    // if (this.state.connectYoutube === 2) {
    //   this.setState({
    //     connectYoutube: 0,
    //   });
    // }
  }

  connectTikTok = () => {
    const { user } = this.props.auth;
    // Ensure tiktok object exists before trying to access its properties
    if (user.connectedAccounts.tiktok && (user.connectedAccounts.tiktok.id || user.connectedAccounts.tiktok.username)) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/tiktok'); // Backend endpoint to initiate TikTok OAuth
    // State update for 'connecting' visual feedback might be too brief due to immediate redirect.
    // Consider managing 'isLoading' globally via Redux based on PENDING action types if more explicit feedback is needed.
  }

  disconnectTwitch = () => {
    const { token, user } = this.props.auth;
    this.props.disconnectTwitch(token, user); // Assuming disconnectTwitch is passed as a prop
  }

  disconnectYoutube = () => {
    const { token, user } = this.props.auth;
    this.props.disconnectYoutube(token, user); // Assuming disconnectYoutube is passed as a prop
  }
  
  // Placeholder for disconnectTikTok - implement if needed
  disconnectTikTok = () => {
    const { token, user } = this.props.auth;
    if (this.props.disconnectTikTok) { // Check if the prop is passed
        this.props.disconnectTikTok(token, user);
    } else {
        console.warn('disconnectTikTok prop not provided to ConnectPlatforms');
    }
  }

  connectSteam = () => {
    const { user } = this.props.auth;
    if (user.connectedAccounts.steam && (user.connectedAccounts.steam.id || user.connectedAccounts.steam.username)) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/tikTok');
    if (this.state.connectSteam === 2) {
      this.setState({
        connectSteam: 0,
      });
    }
  }

  connectFaceBook = () => {
    const { user } = this.props.auth;
    if (user.connectedAccounts.steam && (user.connectedAccounts.steam.id || user.connectedAccounts.steam.username)) {
      return;
    }
    window.location.href = localeURI('/api/v1/auth/facebook');
    if (this.state.connectSteam === 2) {
      this.setState({
        connectSteam: 0,
      });
    }
  }

  render() {
    const { user } = this.props.auth;
    const platforms = [
      {
        key: 'twitch',
        logo: welcome1,
        platformName: 'Twitch',
        connect: this.connectTwitch,
        username: user.connectedAccounts.twitch?.username,
        id: user.connectedAccounts.twitch?.id,
        stateKey: 'connectTwitch',
        hoverKey: 'connected_hovered_twitch',
      },
      {
        key: 'twitter',
        logo: twitter_logo,
        platformName: 'Twitter',
        connect: this.connectTwitter,
        username: user.connectedAccounts.twitter?.username,
        id: user.connectedAccounts.twitter?.id,
        stateKey: 'connectTwitter',
        hoverKey: 'connected_hovered_twitter',
      },
      // {
      //   key: 'steam',
      //   logo: steam_logo,
      //   platformName: 'Steam',
      //   connect: this.connectSteam,
      //   username: user.connectedAccounts.steam?.username,
      //   id: user.connectedAccounts.steam?.id,
      //   stateKey: 'connectSteam',
      //   hoverKey: 'connected_hovered_steam',
      // },
      {
        key: 'youtube',
        logo: youtube_logo,
        platformName: 'YouTube',
        connect: this.connectYoutube,
        username: user.connectedAccounts.youtube?.username,
        id: user.connectedAccounts.youtube?.id,
        stateKey: 'connectYoutube',
        hoverKey: 'connected_hovered_youtube',
      },
      // {
      //   key: 'facebook',
      //   logo: facebook_logo,
      //   platformName: 'FaceBook',
      //   connect: this.connectFaceBook,
      //   username: user.connectedAccounts.facebook?.username,
      //   id: user.connectedAccounts.facebook?.id,
      //   stateKey: 'connectFaceBook',
      //   hoverKey: 'connected_hovered_facebook',
      // },
      // {
      //   key: 'tiktok',
      //   logo: tiktok_logo,
      //   platformName: 'TikTok',
      //   connect: this.connectTikTok,
      //   username: user.connectedAccounts.tiktok?.username,
      //   id: user.connectedAccounts.tiktok?.id,
      //   stateKey: 'connectTikTok',
      //   hoverKey: 'connected_hovered_tiktok',
      // },
    ];

    return (
      <div className="ConnectPlatforms">
        <div className="ConnectPlatforms--squares">
          {platforms.map(platform => {
            const connected = !!(platform.id || platform.username);
            const connecting = this.state[platform.stateKey] === 1;
            const not_connected = !connected && this.state[platform.stateKey] === 0;
            const hover = this.state[platform.hoverKey];
            // 统一基础类名，附加平台和状态类
            const squareClass = classNames(
              'ConnectPlatforms--square',
              `ConnectPlatforms--${platform.key}`,
              {
                connected,
                connecting,
                not_connected
              }
            );
            return (
              <div
                key={platform.key}
                onClick={platform.connect}
                className={squareClass}
                onMouseOver={() => this.setState({ [platform.hoverKey]: true })}
                onMouseLeave={() => this.setState({ [platform.hoverKey]: false })}
                aria-hidden
              >
                {connected && !hover &&
                  <div className="ConnectPlatforms--check">
                    <img className="check_icon" src={check_logo} alt="Connected" />
                  </div>
                }
                <div className="ConnectPlatforms--inner">
                  <div className="ConnectPlatforms--inner1">
                    <img className="responsive" src={platform.logo} alt={`${platform.platformName} Logo`} />
                  </div>
                  <div className="ConnectPlatforms--inner2">
                    <button className="ConnectPlatforms--disconnected">Connect</button>
                    <button className="ConnectPlatforms--connected desktop">
                      {(hover && connected && platform.username) ? `Connected as ${platform.username}` : 'Connected'}
                    </button>
                    <button
                      className={classNames('ConnectPlatforms--connected', 'mobile', { connected })}
                    >
                      Connected as {platform.username}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

ConnectPlatforms.propTypes = {
  // auth: PropTypes.object.isRequired, // Example: ensure auth prop is defined
  // disconnectTwitch: PropTypes.func.isRequired,
  // disconnectYoutube: PropTypes.func.isRequired,
  // disconnectTikTok: PropTypes.func, // Optional, if you implement it
};

export default ConnectPlatforms;
